import { Injectable } from '@angular/core';
import { HttpClient, HttpHeaders, HttpParams } from '@angular/common/http';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';
import { environment } from '../environments/environment';
import { GirisResponse } from '../model/giris-response';
import { Todo } from '../model/todo';
import { Sube } from '../model/sube';
import { Kullanici } from '../model/kullanici';
import { KullaniciGrup } from '../model/kullanici-grup';
import { Talep } from '../model/talep';
import { GirisRequest } from '../model/giris-request';
import { TalepTur } from '../model/talep-tur';
import { UrunGrup } from '../model/urun-grup';
import { StokListePage } from '../model/stok-liste-page';
import { TaleplerPage } from '../model/talepler-page';
import { UploadedFile } from '../model/uploaded-file';
import { IdIsimDto } from '../model/id-isim-dto';
import { TalepOnaySeviye } from '../model/talep-onay-seviye';
import { KullaniciSubeDuzenleRequest } from '../model/kullanici-sube-duzenle-request';
import { TalepOnaylaRequest } from '../model/talep-onayla-request';
import { TalepTalepOnaySeviye } from '../model/talep-talep-onay-seviye';
import { Cari } from '../model/cari';
import { CariListePage } from '../model/cari-liste-page';
import { TeklifOlusturRequest } from '../model/teklif-olustur-request';
import { Teklif } from '../model/teklif';
import { TeklifGirRequest } from '../model/teklif-gir-request';
import { TekliflerPage } from '../model/teklifler-page';
import { TalepKaydetRequest } from '../model/talep-kaydet-request';
import { SiparislerPage } from '../model/siparisler-page';
import { SiparisOlusturRequest } from '../model/siparis-olustur-request';
import { Siparis } from '../model/siparis';
import { IrsaliyelerPage } from '../model/irsaliyeler-page';
import { Irsaliye } from '../model/irsaliye';
import { Master } from '../model/master';
import { MasterListPage } from '../model/master-list-page';
import { Yetki } from '../model/yetki';
import { KullaniciGrupYetkiDuzenleRequest } from '../model/kullanici-grup-yetki-duzenle-request';
import { IrsaliyeOlusturRequest } from '../model/irsaliye-olustur-request';
import { Fatura } from 'src/model/fatura';
import { FaturaKaydetRequest } from 'src/model/fatura-kaydet-request';
import { FaturalarPage } from 'src/model/faturalar-page';
import { FaturaFaturaOnaySeviye } from 'src/model/fatura-fatura-onay-seviye';
import { FaturaOnaylaRequest } from 'src/model/fatura-onayla-request';
import { MailRequest } from 'src/model/mail-request';
import { SiparisSiparisOnaySeviye } from 'src/model/siparis-siparis-onay-seviye';
import { TalepAciklama } from 'src/model/talep-aciklama';
import { TeklifFiyatDegisiklik } from 'src/model/teklif-fiyat-degisiklik';
import { Lojistik } from 'src/model/lojistik';
import { LojistiklerPage } from 'src/model/lojistikler-page';
import { MazotFiyatlarPage } from 'src/model/mazot-fiyatlar-page';
import { LojistikFiyatArsiv } from 'src/model/lojistik-fiyat-arsiv';
import { LojistikKaydetRequest } from 'src/model/lojistik-kaydet-request';
import { LojistikIrsaliyelerPage } from 'src/model/lojistik-irsaliyeler-page';
import { LojistikIrsaliyeKalem } from 'src/model/lojistik-irsaliye-kalem';
import { LojistikIrsaliyeKalemMiktarOnaylananlarPage } from 'src/model/lojistik-irsaliye-kalem-miktar-onaylananlar-page';
import { LojistikIrsaliyeKalemMiktarOnaylanan } from 'src/model/lojistik-irsaliye-kalem-miktar-onaylanan';
import { LojistikFaturaKaydetRequest } from 'src/model/LojistikFaturaKaydetRequest';
import { LojistikFatura } from 'src/model/lojistik-fatura';
import { ResultItems } from 'src/model/resultItems';
import { Dashboard } from 'src/model/dashboard';
import { DuyuruListDTO } from 'src/model/duyuru-list-dto';
import { Duyuru } from 'src/model/duyuru';

@Injectable({
  providedIn: 'root',
})
export class RestService {

  constructor(public http: HttpClient) { 
  }

  endpoint = environment.endpoint;

  giris(body: GirisRequest): Observable<GirisResponse> {
    return this.http.post<GirisResponse>(this.endpoint + 'Kullanici/Giris', JSON.stringify(body))
      .pipe(map(res => new GirisResponse(res)));
  }

  kullaniciDetay(id: any): Observable<Kullanici> {
    return this.http.get<Kullanici[]>(this.endpoint + 'Kullanici/KullaniciDetay/' + id)
      .pipe(map(res => new Kullanici(res)));
  }

  kullanicilar(): Observable<any> {
    return this.http.get<any>(this.endpoint + 'Kullanici/Kullanicilar')
      .pipe(map(res => res));
    // .pipe(map(res => res.map(p => new Kullanici(p))));
  }

  subeKullanicilar(id: any): Observable<Todo> {
    return this.http.get<Todo>(this.endpoint + 'Kullanici/SubeKullanicilar/' + id)
      .pipe(map(res => new Todo(res)));
  }

  grupKullanicilar(id: any): Observable<Kullanici[]> {
    return this.http.get<Kullanici[]>(this.endpoint + 'Kullanici/GrupKullanicilar/' + id)
      .pipe(map(res => res.map(p => new Kullanici(p))));
  }

  kullaniciEkle(request: Kullanici): Observable<Kullanici> {
    return this.http.post<Kullanici>(this.endpoint + 'Kullanici/KullaniciEkle', JSON.stringify(request))
      .pipe(map(res => 
        {
          return new Kullanici(res);
        }
        ));
  }

  kullaniciDuzenle(request: Kullanici): Observable<Kullanici> {
    return this.http.post<Kullanici>(this.endpoint + 'Kullanici/KullaniciDuzenle', JSON.stringify(request))
      .pipe(map(res => 
        {
          return new Kullanici(res)
        }
      ));
  }

  kullaniciSil(id: any): Observable<Todo> {
    return this.http.post<Todo>(this.endpoint + 'Kullanici/KullaniciSil/' + id, {})
      .pipe(map(res => new Todo(res)));
  }

  kullaniciGruplar(): Observable<KullaniciGrup[]> {
    return this.http.get<KullaniciGrup[]>(this.endpoint + 'KullaniciGrup/KullaniciGruplar')
      .pipe(map(res => res.map(p => new KullaniciGrup(p))));
  }

  getKullaniciGrup(id: any): Observable<KullaniciGrup> {
    return this.http.get<KullaniciGrup>(this.endpoint + 'KullaniciGrup/KullaniciGrup/' + id)
      .pipe(map(res => new KullaniciGrup(res)));
  }

  kullaniciGrupEkle(request: Todo): Observable<Todo> {
    return this.http.post<Todo>(this.endpoint + 'KullaniciGrup/KullaniciGrupEkle', JSON.stringify(request))
      .pipe(map(res => new Todo(res)));
  }

  kullaniciGrupDuzenle(request: Todo): Observable<Todo> {
    return this.http.post<Todo>(this.endpoint + 'KullaniciGrup/KullaniciGrupDuzenle', JSON.stringify(request))
      .pipe(map(res => new Todo(res)));
  }

  kullaniciGrupSil(id: any): Observable<Todo> {
    return this.http.post<Todo>(this.endpoint + 'KullaniciGrup/KullaniciGrupSil/' + id, {})
      .pipe(map(res => new Todo(res)));
  }

  kullaniciGrupYetkiler(id: any): Observable<Todo> {
    return this.http.get<Todo>(this.endpoint + 'KullaniciGrupYetki/KullaniciGrupYetkiler')
      .pipe(map(res => new Todo(res)));
  }

  kullaniciSubeleri(): Observable<Sube[]> {
    return this.http.get<Sube[]>(this.endpoint + 'KullaniciSube/KullaniciSubeleri')
      .pipe(map(res => res.map(p => new Sube(p))));
  }

  kullaniciSubeDuzenle(request: KullaniciSubeDuzenleRequest): Observable<any> {
    return this.http.post<any>(this.endpoint + 'KullaniciSube/KullaniciSubeDuzenle', JSON.stringify(request))
      .pipe(map(res => res));
  }

  subeler(): Observable<Sube[]> {
    return this.http.get<Sube[]>(this.endpoint + 'Sube/Subeler')
      .pipe(map(res => res.map(p => new Sube(p))));
  }

  getSube(id: any): Observable<IdIsimDto> {
    return this.http.get<IdIsimDto>(this.endpoint + 'Sube/Sube/' + id)
      .pipe(map(res => new IdIsimDto(res)));
  }

  subeEkle(request: IdIsimDto): Observable<Sube> {
    return this.http.post<Sube>(this.endpoint + 'Sube/SubeEkle', JSON.stringify(request))
      .pipe(map(res => new Sube(res)));
  }

  subeDuzenle(request: IdIsimDto): Observable<Sube> {
    return this.http.post<Sube>(this.endpoint + 'Sube/SubeDuzenle', JSON.stringify(request))
      .pipe(map(res => new Sube(res)));
  }

  subeSil(id: any): Observable<Todo> {
    return this.http.post<Todo>(this.endpoint + 'Sube/SubeSil/' + id, {})
      .pipe(map(res => new Todo(res)));
  }

  talepler(page: number, pageSize: number, durum: number[], text: string, isOnayimdakiler: boolean = false, sayfa: number = null, talepTip: number = null,order:boolean=false): Observable<TaleplerPage> {
    let params = new HttpParams();
    params = params.append('text', text);
    params = params.append('isOnayimdakiler', isOnayimdakiler.toString());
    params = params.append('page', page.toString());
    params = params.append('pageSize', pageSize.toString());
    params = params.append('orderByCanCreateOrder',order.toString())
    if (durum != null) {
      for (const d of durum) {
        params = params.append('durum', d.toString());
      }
    }

    if (sayfa != null)
      params = params.append('sayfa', sayfa.toString());

    if (talepTip != null)
      params = params.append('talepTip', talepTip.toString());

    return this.http.get<TaleplerPage>(this.endpoint + 'TalepTalepKalem/Talepler', { params })
      .pipe(map(res => new TaleplerPage(res)));
  }

  getSiparisVerilecekler(page: number, pageSize: number, durum: number[], text: string, isOnayimdakiler: boolean = false, sayfa: number = null, talepTip: number = null): Observable<Talep[]> {
    let params = new HttpParams();
    params = params.append('text', text);
    params = params.append('isOnayimdakiler', isOnayimdakiler.toString());
    params = params.append('page', page.toString());
    params = params.append('pageSize', pageSize.toString());
    if (durum != null) {
      for (const d of durum) {
        params = params.append('durum', d.toString());
      }
    }

    if (sayfa != null)
      params = params.append('sayfa', sayfa.toString());

    if (talepTip != null)
      params = params.append('talepTip', talepTip.toString());

    return this.http.get<Talep[]>(this.endpoint + 'TalepTalepKalem/GetSiparisVerilecekler', { params })
      .pipe(map(res => res.map(p => new Talep(p))));
  }

  siparisBekleyenTalepler(page: number, pageSize: number, text: string): Observable<TaleplerPage> {
    let params = new HttpParams();
    params = params.append('text', text);
    params = params.append('page', page.toString());
    params = params.append('pageSize', pageSize.toString());
    return this.http.get<TaleplerPage>(this.endpoint + 'TalepTalepKalem/SiparisBekleyenTalepler', { params })
      .pipe(map(res => new TaleplerPage(res)));
  }

  talepDetaylar(id: any): Observable<Talep> {
    return this.http.get<Talep>(this.endpoint + 'TalepTalepKalem/TalepDetaylar/' + id)
      .pipe(map(res => new Talep(res)));
  }

  talepKaydet(request: TalepKaydetRequest): Observable<Talep> {
    debugger
    return this.http.post<Talep>(this.endpoint + 'TalepTalepKalem/TalepKaydet', JSON.stringify(request))
      .pipe(map(res => new Talep(res)));
  }

  /**
   * Şubeye göre talep'leri getirir.
   * @param id seçilen şubenin id'sini verir. 
   * @returns talepleri array biçimde gönderir
   */
  getSubeTalep(id: number): Observable<Dashboard> {
    return this.http.get<Dashboard>(this.endpoint + 'TalepTalepKalem/GetSubeTalep/' + id)
      .pipe(map(res => new Dashboard(res)));
  }

  getAllSubeTalep(){
    return this.http.get(this.endpoint + 'TalepTalepKalem/GetAllSubeTalep')
  }

  ExcelYukle(data): Observable<any>{
    return this.http.post<any>(this.endpoint + 'Lojistik/ExcelYukle',data)
  }

  kalemAra(text: string, subeKodu: number, page: number, pageSize: number): Observable<StokListePage> {
    debugger;
    let params = new HttpParams();
    params = params.append('text', text);
    params = params.append('subeKodu', subeKodu.toString());
    params = params.append('page', page.toString());
    params = params.append('pageSize', pageSize.toString());
    return this.http.get<StokListePage>(this.endpoint + 'TalepTalepKalem/KalemAra', { params })
      .pipe(map(res => new StokListePage(res)));
  }

  talepTurler(): Observable<TalepTur[]> {
    return this.http.get<TalepTur[]>(this.endpoint + 'TalepTur/TalepTurler')
      .pipe(map(res => res.map(p => new TalepTur(p))));
  }

  getTalepTur(id: any): Observable<TalepTur> {
    return this.http.get<TalepTur>(this.endpoint + 'TalepTur/TalepTur/' + id)
      .pipe(map(res => new TalepTur(res)));
  }

  getEntity(id: any): Observable<Master> {
    return this.http.get<Master>(this.endpoint + 'Master/GetEntity/' + id)
      .pipe(map(res => new Master(res)));
  }

  talepTurEkle(request: TalepTur): Observable<TalepTur> {
    return this.http.post<TalepTur>(this.endpoint + 'TalepTur/TalepTurEkle', JSON.stringify(request))
      .pipe(map(res => new TalepTur(res)));
  }

  talepTurDuzenle(request: TalepTur): Observable<TalepTur> {
    return this.http.post<TalepTur>(this.endpoint + 'TalepTur/TalepTurDuzenle', JSON.stringify(request))
      .pipe(map(res => new TalepTur(res)));
  }

  talepTurSil(id: any): Observable<any> {
    return this.http.post<Todo>(this.endpoint + 'TalepTur/TalepTurSil/' + id, {})
      .pipe(map(res => res));
  }

  urunGruplar(parent: any): Observable<UrunGrup[]> {
    let params = new HttpParams();
    if (parent) {
      params = params.append('parent', parent.toString());
    }
    return this.http.get<UrunGrup[]>(this.endpoint + 'UrunGrup/UrunGruplar', { params })
      .pipe(map(res => res.map(p => new UrunGrup(p))));
  }

  getUrunGrup(id: any): Observable<UrunGrup> {
    return this.http.get<UrunGrup>(this.endpoint + 'UrunGrup/UrunGrup/' + id)
      .pipe(map(res => new UrunGrup(res)));
  }

  urunGrupEkle(request: UrunGrup): Observable<Todo> {
    return this.http.post<UrunGrup>(this.endpoint + 'UrunGrup/UrunGrupEkle', JSON.stringify(request))
      .pipe(map(res => new UrunGrup(res)));
  }

  urunGrupDuzenle(request: UrunGrup): Observable<UrunGrup> {
    return this.http.post<UrunGrup>(this.endpoint + 'UrunGrup/UrunGrupDuzenle', JSON.stringify(request))
      .pipe(map(res => new UrunGrup(res)));
  }

  urunGrupSil(id: any): Observable<Todo> {
    return this.http.post<Todo>(this.endpoint + 'UrunGrup/UrunGrupSil/' + id, {})
      .pipe(map(res => new Todo(res)));
  }

  uploadFile(file): Observable<UploadedFile> {
    const formdata: FormData = new FormData();
    formdata.append('file', file);
    return this.http.post<UploadedFile>(this.endpoint + 'Files/UploadFile', formdata)
      .pipe(map(res => new UploadedFile(res)));
  }

  uploadFiles(files: string[]): Observable<any> {
    const formdata: FormData = new FormData();
    for (const file of files) {
      formdata.append('files', file);
    }
    return this.http.post<any>(this.endpoint + 'Files/UploadFiles', formdata);
  }

  downloadFile(fileName: string): Observable<any> {
    return this.http.get(this.endpoint + 'Files/DownloadFile/' + fileName, { responseType: 'blob' })
      .pipe(map(res => {
        var downloadURL = window.URL.createObjectURL(res);
        window.open(downloadURL, '_blank');
        // var link = document.createElement('a');
        // link.href = downloadURL;
        // link.download = fileName;
        // link.click();
      }));
  }

  talepOnaySeviyeler(): Observable<TalepOnaySeviye[]> {
    return this.http.get<TalepOnaySeviye[]>(this.endpoint + 'TalepOnaySeviye/TalepOnaySeviyeler')
      .pipe(map(res => res.map(p => new TalepOnaySeviye(p))));
  }

  talepOnaySeviye(id: any): Observable<any> {
    return this.http.get<any>(this.endpoint + 'TalepOnaySeviye/TalepOnaySeviye/' + id)
      .pipe(map(res => res));
  }

  /*talepOnaySeviyeEkleHazirla(): Observable<TalepOnaySeviyeData> {
    return this.http.get<TalepOnaySeviyeData>(this.endpoint + 'TalepOnaySeviye/TalepOnaySeviyeEkleHazirla')
      .pipe(map(res => new TalepOnaySeviyeData(res)));
  }*/

  talepOnaySeviyeEkle(request: any): Observable<TalepTur> {
    return this.http.post<any>(this.endpoint + 'TalepOnaySeviye/TalepOnaySeviyeEkle', JSON.stringify(request))
      .pipe(map(res => res));
  }

  talepOnaySeviyeDuzenle(request: any): Observable<any> {
    return this.http.post<any>(this.endpoint + 'TalepOnaySeviye/TalepOnaySeviyeDuzenle', JSON.stringify(request))
      .pipe(map(res => res));
  }

  talepOnaySeviyeSil(id: any): Observable<any> {
    return this.http.post<any>(this.endpoint + 'TalepOnaySeviye/TalepOnaySeviyeSil/' + id, {})
      .pipe(map(res => res));
  }

  talepOnayla(request: TalepOnaylaRequest): Observable<any> {
    return this.http.post<any>(this.endpoint + 'TalepTalepKalem/TalepOnayla', JSON.stringify(request))
      .pipe(map(res => res));
  }

  getTalepHareketler(id: any): Observable<TalepTalepOnaySeviye[]> {
    return this.http.get<any>(this.endpoint + 'TalepTalepOnaySeviye/GetTalepHareketler/' + id)
      .pipe(map(res => res.map(p => new TalepTalepOnaySeviye(p))));
  }

  cariler(page: number, pageSize: number): Observable<CariListePage> {
    let params = new HttpParams();
    params = params.append('page', page.toString());
    params = params.append('pageSize', pageSize.toString());
    return this.http.get<CariListePage>(this.endpoint + 'Cari/Cariler', { params })
      .pipe(map(res => new CariListePage(res)));
  }

  cariAra(text: string, page: number, pageSize: number): Observable<CariListePage> {
    let params = new HttpParams();
    params = params.append('text', text);
    params = params.append('page', page.toString());
    params = params.append('pageSize', pageSize.toString());
    return this.http.get<CariListePage>(this.endpoint + 'Cari/CariAra', { params })
      .pipe(map(res => new CariListePage(res)));
  }

  cariEkle(request: Cari): Observable<Cari> {
    return this.http.post<any>(this.endpoint + 'Cari/CariEkle', JSON.stringify(request))
      .pipe(map(res => new Cari(res)));
  }

  cariDuzenle(request: Cari): Observable<Cari> {
    return this.http.post<any>(this.endpoint + 'Cari/CariDuzenle', JSON.stringify(request))
      .pipe(map(res => new Cari(res)));
  }

  cariSil(id: any): Observable<any> {
    return this.http.post<any>(this.endpoint + 'Cari/CariSil/' + id, {})
      .pipe(map(res => res));
  }

  cariDetay(id: any): Observable<Cari> {
    return this.http.get<any>(this.endpoint + 'Cari/CariDetay/' + id)
      .pipe(map(res => new Cari(res)));
  }

  cariBul(tcVergi: string, which: number): Observable<Number> {
    return this.http.get<any>(this.endpoint + 'Cari/CariBul/' + tcVergi + "/" + which)
      .pipe(map(res => res));
  }

  cariAccess(key: string): Observable<Cari> {
    return this.http.get<any>(this.endpoint + 'Cari/CariAccess/' + key)
      .pipe(map(res => new Cari(res)));
  }

  getMasterTypes(types: string[]): Observable<any> {
    let params = new HttpParams();
    if (types != null) {
      for (const d of types) {
        params = params.append('types', d.toString());
      }
    }
    return this.http.get<any>(this.endpoint + 'Master/GetEntities', { params })
      .pipe(map(res => res));
  }

  teklifOlustur(request: TeklifOlusturRequest): Observable<any> {
    return this.http.post<any>(this.endpoint + 'Teklif/TeklifOlustur', JSON.stringify(request))
      .pipe(map(res => res));
  }

  teklif(id: any): Observable<Teklif> {
    return this.http.get<Teklif>(this.endpoint + 'Teklif/Teklif/' + id)
      .pipe(map(res => new Teklif(res)));
  }

  teklifByAccessKey(accessKey: any): Observable<Teklif> {
    return this.http.post<Teklif>(this.endpoint + 'Teklif/TeklifByAccessKey', { key: accessKey })
      .pipe(map(res => new Teklif(res)));
  }

  teklifler(page: number, pageSize: number, durum: number[], text: string): Observable<TekliflerPage> {
    let params = new HttpParams();
    params = params.append('text', text);
    params = params.append('page', page.toString());
    params = params.append('pageSize', pageSize.toString());
    if (durum != null) {
      for (const d of durum) {
        params = params.append('durum', d.toString());
      }
    }
    return this.http.get<TekliflerPage>(this.endpoint + 'Teklif/Teklifler', { params })
      .pipe(map(res => new TekliflerPage(res)));
  }

  siparisler(page: number, pageSize: number, durum: number[], text: string, isOnayimdakiler: boolean = false): Observable<SiparislerPage> {
    let params = new HttpParams();
    params = params.append('text', text);
    params = params.append('isOnayimdakiler', isOnayimdakiler.toString());
    params = params.append('page', page.toString());
    params = params.append('pageSize', pageSize.toString());
    if (durum != null) {
      for (const d of durum) {
        params = params.append('durum', d.toString());
      }
    }
    return this.http.get<SiparislerPage>(this.endpoint + 'Siparis/Siparisler', { params })
      .pipe(map(res => new SiparislerPage(res)));
  }

  siparislerIrsaliyePage(page: number, pageSize: number, durum: number[], text: string, isOnayimdakiler: boolean = false): Observable<SiparislerPage> {
    let params = new HttpParams();
    params = params.append('text', text);
    params = params.append('isOnayimdakiler', isOnayimdakiler.toString());
    params = params.append('page', page.toString());
    params = params.append('pageSize', pageSize.toString());
    params = params.append('pageName', "irsaliye");
    if (durum != null) {
      for (const d of durum) {
        params = params.append('durum', d.toString());
      }
    }
    return this.http.get<SiparislerPage>(this.endpoint + 'Siparis/Siparisler', { params })
      .pipe(map(res => new SiparislerPage(res)));
  }

  teklifKaydet(request: TeklifGirRequest): Observable<any> {
    return this.http.post<any>(this.endpoint + 'Teklif/TeklifKaydet', JSON.stringify(request))
      .pipe(map(res => res));
  }

  talepTeklifler(talepId: any): Observable<Teklif[]> {
    return this.http.get<Teklif[]>(this.endpoint + 'Teklif/TalepTeklifler/' + talepId)
      .pipe(map(res => res.map(p => new Teklif(p))));
  }

  siparisOlustur(request: SiparisOlusturRequest): Observable<Siparis[]> {
    return this.http.post<Siparis[]>(this.endpoint + 'Siparis/SiparisOlustur', JSON.stringify(request))
      .pipe(map(res => res.map(p => new Siparis(p))));
  }

  siparis(id: any): Observable<Siparis> {
    return this.http.get<Siparis>(this.endpoint + 'Siparis/Siparis/' + id)
      .pipe(map(res => new Siparis(res)));
  }

  siparisIrsaliyeleri(id: any): Observable<Irsaliye[]> {
    return this.http.get<Irsaliye[]>(this.endpoint + 'Irsaliye/SiparisIrsaliyeleri/' + id)
      .pipe(map(res => res.map(p => new Irsaliye(p))));
  }

  siparisOnay(id: number, durumParam: number): Observable<any> {
    return this.http.post<any>(this.endpoint + 'Siparis/SiparisOnay/' + id, { durum: durumParam })
      .pipe(map(res => new Siparis(res)));
  }

  irsaliyeKaydet(request: IrsaliyeOlusturRequest): Observable<any> {
    return this.http.post<any>(this.endpoint + 'Irsaliye/IrsaliyeKaydet', JSON.stringify(request))
      .pipe(map(res => res));
  }

  irsaliyeler(page: number, pageSize: number, durum: number[], text: string): Observable<IrsaliyelerPage> {
    let params = new HttpParams();
    params = params.append('text', text);
    params = params.append('page', page.toString());
    params = params.append('pageSize', pageSize.toString());
    if (durum != null) {
      for (const d of durum) {
        params = params.append('durum', d.toString());
      }
    }
    return this.http.get<IrsaliyelerPage>(this.endpoint + 'Irsaliye/Irsaliyeler', { params })
      .pipe(map(res => new IrsaliyelerPage(res)));
  }

  irsaliye(id: any): Observable<Irsaliye> {
    return this.http.get<any>(this.endpoint + 'Irsaliye/Irsaliye/' + id)
      .pipe(map(res => new Irsaliye(res)));
  }

  netsisCariAktar(preview: boolean): Observable<Cari[]> {
    return this.http.post<Cari[]>(this.endpoint + 'Cari/CariAktar/' + preview, {})
      .pipe(map(res => res.map(p => new Cari(p))));
  }

  sarfYeriAktar(preview: boolean): Observable<Master[]> {
    return this.http.post<Cari[]>(this.endpoint + 'Master/SarfYeriAktar/' + preview, {})
      .pipe(map(res => res.map(p => new Master(p))));
  }

  getEntitiesPage(page: number, pageSize: number, types: string[]): Observable<MasterListPage> {
    let params = new HttpParams();
    params = params.append('page', page.toString());
    params = params.append('pageSize', pageSize.toString());
    if (types != null) {
      for (const d of types) {
        params = params.append('types', d.toString());
      }
    }
    return this.http.get<MasterListPage>(this.endpoint + 'Master/GetEntitiesPage', { params })
      .pipe(map(res => new MasterListPage(res)));
  }

  masterEkle(request: Master): Observable<Master> {
    return this.http.post<Master>(this.endpoint + 'Master/MasterEkle', JSON.stringify(request))
      .pipe(map(res => new Master(res)));
  }

  masterDuzenle(request: Master): Observable<Master> {
    return this.http.post<Master>(this.endpoint + 'Master/MasterDuzenle', JSON.stringify(request))
      .pipe(map(res => new Master(res)));
  }

  masterSil(id: any): Observable<any> {
    return this.http.post<Todo>(this.endpoint + 'Master/MasterSil/' + id, {})
      .pipe(map(res => res));
  }

  getYetkiler(): Observable<Yetki[]> {
    return this.http.get<Yetki[]>(this.endpoint + 'Yetki/Yetkiler')
      .pipe(map(res => res.map(p => new Yetki(p))));
  }

  kullaniciGrupYetkiDuzenle(request: KullaniciGrupYetkiDuzenleRequest): Observable<any> {
    return this.http.post<any>(this.endpoint + 'KullaniciGrupYetki/KullaniciGrupYetkiDuzenle', JSON.stringify(request))
      .pipe(map(res => res));
  }

  netsisAktar(id: any): Observable<any> {
    return this.http.post<any>(this.endpoint + 'Irsaliye/NetsisAktar/' + id, {})
      .pipe(map(res => res));
  }

  faturaDetaylar(id: any): Observable<Fatura> {
    return this.http.get<Fatura>(this.endpoint + 'Fatura/FaturaDetaylar/' + id)
      .pipe(map(res => new Fatura(res)));
  }

  faturaKaydet(request: FaturaKaydetRequest): Observable<Fatura> {
    return this.http.post<Fatura>(this.endpoint + 'Fatura/FaturaKaydet', JSON.stringify(request))
      .pipe(map(res => new Fatura(res)));
  }

  faturalar(page: number, pageSize: number, durum: number[], isAktarildi: boolean, text: string, isOnayimdakiler: boolean = false): Observable<FaturalarPage> {
    let params = new HttpParams();
    params = params.append('isAktarildi', isAktarildi.toString());
    params = params.append('text', text);
    params = params.append('isOnayimdakiler', isOnayimdakiler.toString());
    params = params.append('page', page.toString());
    params = params.append('pageSize', pageSize.toString());
    if (durum != null) {
      for (const d of durum) {
        params = params.append('durum', d.toString());
      }
    }
    return this.http.get<FaturalarPage>(this.endpoint + 'Fatura/Faturalar', { params })
      .pipe(map(res => new FaturalarPage(res)));
  }

  getFaturaHareketler(id: any): Observable<FaturaFaturaOnaySeviye[]> {
    return this.http.get<any>(this.endpoint + 'FaturaFaturaOnaySeviye/GetFaturaHareketler/' + id)
      .pipe(map(res => res.map(p => new FaturaFaturaOnaySeviye(p))));
  }

  faturaOnayla(request: FaturaOnaylaRequest): Observable<any> {
    return this.http.post<any>(this.endpoint + 'Fatura/FaturaOnayla', JSON.stringify(request))
      .pipe(map(res => res));
  }

  netsisFaturaAktar(id: any): Observable<any> {
    return this.http.post<any>(this.endpoint + 'Fatura/NetsisAktar/' + id, {})
      .pipe(map(res => res));
  }

  talepSil(id: any): Observable<Todo> {
    debugger;
    return this.http.post<Todo>(this.endpoint + 'TalepTalepKalem/TalepSil/' + id, {})
      .pipe(map(res =>new Todo(res)));
  }

  faturaSil(id: number): Observable<Todo> {
    return this.http.post<Todo>(this.endpoint + 'Fatura/FaturaSil/' + id, {})
      .pipe(map(res => new Todo(res)));
  }

  mailGonder(request: MailRequest): Observable<Todo> {
    return this.http.post<Todo>(this.endpoint + 'Mail/MailGonder/', JSON.stringify(request))
      .pipe(map(res => new Todo(res)));
  }

  mailGonderildi(id: number): Observable<Todo> {
    return this.http.post<Todo>(this.endpoint + 'Teklif/MailGonderildi/' + id, {})
      .pipe(map(res => new Todo(res)));
  }

  getSiparisHareketler(id: any): Observable<SiparisSiparisOnaySeviye[]> {
    return this.http.get<any>(this.endpoint + 'SiparisSiparisOnaySeviye/GetSiparisHareketler/' + id)
      .pipe(map(res => res.map(p => new SiparisSiparisOnaySeviye(p))));
  }

  siparisOnayla(request: SiparisSiparisOnaySeviye): Observable<any> {
    return this.http.post<any>(this.endpoint + 'Siparis/SiparisOnayla', JSON.stringify(request))
      .pipe(map(res => res));
  }

  talepAciklamaKaydet(request: TalepAciklama): Observable<any> {
    return this.http.post<any>(this.endpoint + 'TalepAciklama/AciklamaKaydet', JSON.stringify(request))
      .pipe(map(res => res));
  }

  fiyatDegisiklikKaydet(request: TeklifFiyatDegisiklik[]): Observable<any> {
    return this.http.post<any>(this.endpoint + 'TeklifFiyatDegisiklik/FiyatDegisiklikKaydet', JSON.stringify(request))
      .pipe(map(res => res));
  }

  getTeklifFiyatDegisiklik(id: number): Observable<TeklifFiyatDegisiklik[]> {
    return this.http.get<TeklifFiyatDegisiklik[]>(this.endpoint + 'TeklifFiyatDegisiklik/GetTeklifFiyatDegisiklik/' + id, {})
      .pipe(map(res => res.map(p => new TeklifFiyatDegisiklik(res))));
  }

  getOnaySayisi(id: number): Observable<any> {
    return this.http.get<number>(this.endpoint + 'OnaySayi/GetOnaySayisi/' + id, {})
      .pipe(map(res => res));
  }

  netsisCariKaydet(request: Cari): Observable<any> {
    return this.http.post<any>(this.endpoint + 'Cari/NetsisCariKaydet', JSON.stringify(request))
      .pipe(map(res => res));
  }

  getHesapPlani(hesapKodu: string, hesapAdi: string): Observable<any> {
    let params = new HttpParams();
    params = params.append('hesapKodu', hesapKodu);
    params = params.append('hesapAdi', hesapAdi);
    return this.http.get<any>(this.endpoint + 'Fatura/GetHesapPlani', { params })
      .pipe(map(res => res));
    // .pipe(map(res => res.map(p => new Kullanici(p))));
  }

  talepKalemKaldir(request: TalepKaydetRequest): Observable<Talep> {
    return this.http.post<Talep>(this.endpoint + 'TalepTalepKalem/TalepKalemKaldir', JSON.stringify(request))
      .pipe(map(res => res));
  }

  siparisIptal(id: any): Observable<Todo> {
    return this.http.post<Todo>(this.endpoint + 'Siparis/SiparisSil/' + id, {})
      .pipe(map(res => new Todo(res)));
  }

  siparisKapat(id: any): Observable<ResultItems> {
    return this.http.post<ResultItems>(this.endpoint + 'Siparis/SiparisKapat/' + id, {})
      .pipe(map(res => new ResultItems(res)));
  }

  getLojistik(id: any): Observable<Lojistik> {
    return this.http.get<any>(this.endpoint + 'Lojistik/GetLojistik/' + id)
      .pipe(map(res => new Lojistik(res)));
  }

  aktarildiIsaretle(id: any): Observable<Todo> {
    return this.http.post<Todo>(this.endpoint + 'Fatura/AktarildiIsaretle/' + id, {})
      .pipe(map(res => new Todo(res)));
  }

  lojistikKaydet(lojistik: LojistikKaydetRequest): Observable<Lojistik> {
    return this.http.post<Lojistik>(this.endpoint + 'Lojistik/LojistikKaydet', JSON.stringify(lojistik))
      .pipe(map(res => new Lojistik(res)));
  }

  getLojistikler(page: number, pageSize: number, durum: number[], text: string): Observable<LojistiklerPage> {
    let params = new HttpParams();
    params = params.append('text', text);
    params = params.append('page', page.toString());
    params = params.append('pageSize', pageSize.toString());
    if (durum != null) {
      for (const d of durum) {
        params = params.append('durum', d.toString());
      }
    }
    return this.http.get<LojistiklerPage>(this.endpoint + 'Lojistik/GetLojistikler', { params })
      .pipe(map(res => new LojistiklerPage(res)));
  }

  getLojistikFiyatlar(page: number, pageSize: number, durum: number[], text: string): Observable<MazotFiyatlarPage> {
    let params = new HttpParams();
    params = params.append('text', text);
    params = params.append('page', page.toString());
    params = params.append('pageSize', pageSize.toString());
    if (durum != null) {
      for (const d of durum) {
        params = params.append('durum', d.toString());
      }
    }

    return this.http.get<MazotFiyatlarPage>(this.endpoint + 'LojistikFiyatArsiv/GetLojistikFiyatlar', { params })
      .pipe(map(res => new MazotFiyatlarPage(res)));
  }

  lojistikFiyatSil(f: LojistikFiyatArsiv): Observable<Todo> {
    return this.http.post<Todo>(this.endpoint + 'LojistikFiyatArsiv/FiyatSil', JSON.stringify(f))
      .pipe(map(res => new Todo(res)));
  }

  getLojistikFiyat(id: any): Observable<LojistikFiyatArsiv> {
    return this.http.get<LojistikFiyatArsiv>(this.endpoint + 'LojistikFiyatArsiv/GetLojistikFiyat/' + id)
      .pipe(map(res => new LojistikFiyatArsiv(res)));
  }

  lojistikFiyatKaydet(fiyat: LojistikFiyatArsiv): Observable<LojistikFiyatArsiv> {
    return this.http.post<LojistikFiyatArsiv>(this.endpoint + 'LojistikFiyatArsiv/FiyatKaydet', JSON.stringify(fiyat))
      .pipe(map(res => new LojistikFiyatArsiv(res)));
  }

  getLojistikRotaFiyat(id: any): Observable<Lojistik> {
    return this.http.get<any>(this.endpoint + 'Lojistik/GetLojistikRotaFiyat/' + id)
      .pipe(map(res => new Lojistik(res)));
  }

  getLojistikFiyatArsiv(): Observable<any> {
    return this.http.get<any>(this.endpoint + 'LojistikFiyatArsiv/GetLojistikFiyatArsiv')
      .pipe(map(res => res));
  }


  getLojistikRotaFiyatArsiv(id: number, arsivFiyat: number): Observable<any> {
    let params = new HttpParams();
    params = params.append('id', id.toString());
    params = params.append('arsivFiyat', arsivFiyat.toString());
    return this.http.get<any>(this.endpoint + 'Lojistik/GetLojistikRotaFiyatArsiv', { params })
      .pipe(map(res => res));
  }

  netsisLokasyonAktar(): Observable<any> {
    return this.http.post<any>(this.endpoint + 'Master/LokasyonAktar', {})
      .pipe(map(res => res));
  }

  getLojistikIrsaliyeler(page: number, pageSize: number, basTar: string, bitTar: string, text: string): Observable<LojistikIrsaliyelerPage> {
    let params = new HttpParams();
    params = params.append('text', text);
    params = params.append('page', page.toString());
    params = params.append('pageSize', pageSize.toString());

    if (basTar !== null)
      params = params.append('basTar', basTar.toString());

    if (bitTar !== null)
      params = params.append('bitTar', bitTar.toString());

    return this.http.get<LojistikIrsaliyelerPage>(this.endpoint + 'Netsis/GetLojistikIrsaliyeList', { params })
      .pipe(map(res => new LojistikIrsaliyelerPage(res)));
  }

  getLojistikIrsaliyeKalemler(irsaliyeNo: string, cariKodu: string): Observable<LojistikIrsaliyeKalem[]> {
    let params = new HttpParams();
    params = params.append('irsaliyeNo', irsaliyeNo.toString());
    params = params.append('cariKodu', cariKodu.toString());
    return this.http.get<LojistikIrsaliyeKalem[]>(this.endpoint + 'Netsis/GetLojistikIrsaliyeKalemList', { params })
      .pipe(map(res => res));
  }

  getLojistikIrsaliyeKalemMiktarOnaylananlar(page: number, pageSize: number, basTar: string, bitTar: string, text: string): Observable<LojistikIrsaliyeKalemMiktarOnaylananlarPage> {
    let params = new HttpParams();
    params = params.append('text', text);
    params = params.append('page', page.toString());
    params = params.append('pageSize', pageSize.toString());

    if (basTar !== null)
      params = params.append('basTar', basTar.toString());

    if (bitTar !== null)
      params = params.append('bitTar', bitTar.toString());

    return this.http.get<LojistikIrsaliyeKalemMiktarOnaylananlarPage>(this.endpoint + 'Netsis/GetLojistikIrsaliyeKalemMiktarOnaylananlar', { params })
      .pipe(map(res => new LojistikIrsaliyeKalemMiktarOnaylananlarPage(res)));
  }

  lojistikIrsaliyeKalemOnaylananKaydet(l: LojistikIrsaliyeKalemMiktarOnaylanan): Observable<LojistikIrsaliyeKalemMiktarOnaylanan> {
    return this.http.post<LojistikIrsaliyeKalemMiktarOnaylanan>(this.endpoint + 'LojistikIrsaliyeKalemOnaylanan/LojistikIrsaliyeKalemOnaylananKaydet', JSON.stringify(l))
      .pipe(map(res => res));
  }

  lojistikFaturaKaydet(request: LojistikFaturaKaydetRequest): Observable<LojistikFatura> {
    return this.http.post<LojistikFatura>(this.endpoint + 'LojistikFatura/LojistikFaturaKaydet', JSON.stringify(request))
      .pipe(map(res => new LojistikFatura(res)));
  }

  /**
   * Aktif olan kullanıcıya göre duyuru listesi çağırır.
   * @param userId Aktif kullanıcı idsi
   * @returns DuyuruListDTO[]
   */
  getAllDuyuru(userId: number): Observable<DuyuruListDTO[]> {
    return this.http.get<DuyuruListDTO[]>(this.endpoint + 'api/Duyuru/GetAll/' + userId)
      .pipe(map(res => res));
  }

  /**
  * Yeni duyuru eklemek için kullanılır
  * @param model eklenecek olan duyuru
  * @returns ResultItems
  */
  setDuyuru(model: Duyuru): Observable<ResultItems> {
    return this.http.post<ResultItems>(this.endpoint + 'api/Duyuru/duyuru/add', JSON.parse(JSON.stringify(model)))
      .pipe(map(res => new ResultItems(res)));
  }

  /**
   * Aktif olan kullanıcı duyuru okuduğunda çalışır.
   * @param userId Aktif kullanıcı idsi
   * @returns 
   */
  setDuyuruGoruldu(userId: number, duyuruId: number): any {
    return this.http.get(this.endpoint + 'api/duyuru/setgoruldu/Kullanici/' + userId + '/Duyuru/' + duyuruId + '/');
  }

  getLojistikIrsaliyeListByVkn(vkn: string) {
    return this.http.get(this.endpoint + 'Netsis/lojistikIrsaliyeList/' + vkn);
  }

  getGuzergahType() {
    return this.http.get(this.endpoint + 'Lojistik/guzergah');
  }

  getRotaList(lojistikId: number) {
    return this.http.get(this.endpoint + 'Lojistik/rotalist/' + lojistikId);
  }

  saveGuzergah(guzergah:any){
    return this.http.post(this.endpoint + 'Lojistik/SaveGuzergah',guzergah)
  }


  getGuzergahList(lojistikId: number){
    return this.http.get(this.endpoint + 'Lojistik/guzergahlist/' + lojistikId);
  }

  getSonZamlar(mazotBazFiyati:number,tarih:string){
    return this.http.get(this.endpoint + 'Lojistik/sonzamlar/' + mazotBazFiyati + '/' + tarih);
  }

  enflasyonGuncelle(id:number,enflasyon:number,artis:boolean){
    return this.http.get(this.endpoint + `lojistik/enflasyondegisim/${enflasyon}/${artis}/${id}`);
  }

  mazotDegisim(id:number,oran:string,artis:boolean,cariId:number){
    return this.http.get(this.endpoint + `lojistik/mazotdegisim/${id}/${oran}/${artis}/${cariId}`);
  }

  mazotDegisimGizle(id:number){
    return this.http.get(this.endpoint + `lojistik/mazotdegisimgizle/${id}`);
  }


  getRotaGecmis(id:string){
    return this.http.get(this.endpoint + `lojistik/rotagecmisi/${id}`);
  }

  /**
   * Taşımacı için irsaliye fturalandırma kısmı
   * @param model 
   * @returns 
   */
  tasimaciSaveIrsaliye(model: any){
    return this.http.post(this.endpoint + 'lojistik/tasimaci/save/irsaliye', model);
  }

  tasimaciGetLojistikIrsaliyeListByVkn(vkn: string) {
    return this.http.get(this.endpoint + 'Netsis/tasimaci/lojistikIrsaliyeList/' + vkn);
  }

  deleteLojistik(id:number){
    return this.http.get(this.endpoint + 'Lojistik/kaldir/' + id);
  }

  deleteGuzergah(id:number){
    return this.http.get(this.endpoint + 'Lojistik/guzergah/kaldir/' + id);
  }

  senkronIrsaliye(){
    return this.http.get(this.endpoint + 'netsis/irsaliye/senkron');
  }

  anasayfaGrafikler(){
    return this.http.get(this.endpoint + 'anasayfa/grafikler');
  }

}

